;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('notificationCentral', notificationCentral)

  /* @ngInject */
  function notificationCentral () {
    return {
      restrict: 'E',
      templateUrl: '/core/directives/notification-central/notification-central-directive.html?$$REVISION$$',
      controller: 'NotificationCentralController'
    }
  }
})()
